import React, {Fragment} from 'react'
import {ELEMENTS_IDS} from 'const'
import {LoginPageButton} from '../LogisterPageStyles'
import {SocialButtonsContainer} from './styled'

const {swissIdLogin, facebookLogin, googleLogin, appleLogin} = ELEMENTS_IDS.logisterPage

const SocialLogin = ({
  loginWithSwissID,
  loginWithFacebook,
  loginWithGoogle,
  loginWithApple,
  theme,
  availableMethods = {swissid: true, facebook: true, google: true, apple: true},
}) => (
  <Fragment>
    <SocialButtonsContainer>
      {availableMethods.swissid && (
        <LoginPageButton
          id={swissIdLogin}
          label="buttons.swiss-id"
          {...theme.buttons.swiss}
          onClick={loginWithSwissID}
        />
      )}
      {availableMethods.facebook && (
        <LoginPageButton
          id={facebookLogin}
          label="buttons.facebook"
          {...theme.buttons.facebook}
          onClick={loginWithFacebook}
        />
      )}
    </SocialButtonsContainer>
    <SocialButtonsContainer>
      {availableMethods.google && (
        <LoginPageButton id={googleLogin} label="buttons.google" {...theme.buttons.google} onClick={loginWithGoogle} />
      )}
      {availableMethods.apple && (
        <LoginPageButton label="buttons.apple" id={appleLogin} {...theme.buttons.apple} onClick={loginWithApple} />
      )}
    </SocialButtonsContainer>
  </Fragment>
)

export default SocialLogin
